export function formatCurrency(value: string | number, currency: string="BRL"){
  try {
    let value_aux = value.toString();
    let __return = parseFloat(value_aux).toLocaleString("pt-BR",{style:"currency", currency:currency});
    return __return.split(" ").join(" ");
  } catch (error) {
    return "";
  }
}

export function formatMoneyByCurrency(value:number, currency:number|string){
  if(currency === "1" || currency === 1){
    return formatCurrency(value);
  }

  if(currency === "2" || currency === 2){
    return formatCurrency(value,"USD").replace("US","");
  }

  if(currency === "3" || currency === 3){
    return formatCurrency(value,"EUR");
  }

  return "";
}